import { Pipe, PipeTransform } from '@angular/core';
import { PayInBank, FindOne } from '@univacity/shared/types';
import { Observable, of } from 'rxjs';
import { PayInBankService } from '../services';

@Pipe({
  name: 'payInBank',
  standalone: false,
})
export class PayInBankPipe implements PipeTransform {
  constructor(private service: PayInBankService) {}

  transform(
    payInBank?: string | PayInBank,
    query?: FindOne
  ): Observable<PayInBank | null> {
    if (!payInBank) return of(null);
    if (typeof payInBank === 'string')
      return this.service.findOne(payInBank, query);
    return this.service.findOne(payInBank._id, query);
  }
}
